'use client';

import { Checkbox } from '@veneer/core';
import { useTranslation } from 'react-i18next';

import { NamespacesI18n } from '@storefront/i18n';
import { ModalHub } from '@storefront/shared-components/modal-accessories/modal-hub';
import { ModalMonitor } from '@storefront/shared-components/modal-accessories/modal-monitor';
import { ModalMouseKeyboard } from '@storefront/shared-components/modal-accessories/modal-mouse-keyboard';

import styles from './accessory-card.module.scss';
import { useState } from 'react';
import ThemeProviderWrapper from '@storefront/app/ThemeProviderWrapper';

export type AccessoryCardProps = {
  name: string;
  imageUrl: string;
  price: number;
  description?: string;
  onAddToCart?: () => void;
};
export const AccessoryModal: Record<string, React.ReactNode> = {
  monitor: <ModalMonitor />,
  keyboard: <ModalMouseKeyboard />,
  hub: <ModalHub />,
};

export const AccessoryCard = (accessory: AccessoryCardProps) => {
  const { imageUrl, name, price, description, onAddToCart } = accessory;

  const [isAccessorySelected, setIsAccessorySelected] = useState(false);
  const i18nPrefix = 'pc.accessoryCard';
  const { t } = useTranslation(NamespacesI18n.PDP_CONFIG, {
    keyPrefix: i18nPrefix,
  });

  const handleCheckboxChange = async (
    evt: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsAccessorySelected(!isAccessorySelected);
    onAddToCart && onAddToCart();
  };

  return (
    <div className={styles['container']} data-selected={isAccessorySelected}>
      <div className={styles['checkbox']}>
        <ThemeProviderWrapper theme="accessoryCardTheme">
          <Checkbox
            id="add-accessory-to-cart"
            data-testid="add-accessory-to-cart"
            label={t('checkbox', { name })}
            onChange={handleCheckboxChange}
            checked={isAccessorySelected}
            name={'checkbox-add-accessory-to-cart'}
            className={styles['checkbox']}
          />
        </ThemeProviderWrapper>
      </div>
      <img src={imageUrl} alt={name} className={styles['img']} />
      <div className={`body-regular ${styles['text']}`}>
        <div className={styles['description']}>{description}</div>
        <div className={styles['price']}>{t('price', { price })}</div>
        {AccessoryModal[name]}
      </div>
    </div>
  );
};

export default AccessoryCard;
